import { Field, Form, Formik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { Component } from "react";
import { Button, Checkbox, ControlLabel, Modal } from "react-bootstrap";
import Alert from "react-s-alert";
import * as Yup from "yup";
import history from "../history";
import FormikDatetime from "../Shared/FormikDateTime";
import FormikFormControl from "../Shared/Forms/FormikFormControl";
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from "../utils/DealsService";
import UsersService from "../utils/UsersService";

class CreateLeadModal extends Component {
  state = {
    addDueDate: false,
    users: []
  };

  constructor(props) {
    super(props);
    UsersService.allUsers().then(data => {
      this.setState({ users: data });
    });
  }

  render() {
    const { onCancelSubmit, showModal, onCloseModal } = this.props;

    const validationSchema = Yup.object().shape({
      assign_lead_to: Yup.string(),
      lead_type: Yup.string().required("Type is required"),
      priority: Yup.string().required("Priority is required"),
      due_at: Yup.date().when("lead_type", {
        is: val => this.state.addDueDate,
        then: Yup.date().required("need a due date"),
        otherwise: Yup.date().notRequired()
      }),
      initial_notes: Yup.string().required("Notes are required").min(15, "minimum 15 characters").max(2000, "maximum 2000 characters")
    });

    const { users } = this.state;

    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Create Follow Up for this Deal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              lead_type: "",
              assign_lead_to: "",
              initial_notes: "",
              priority: 3,
              due_at: moment()
                .add(3, "days")
                .hours(8)
                .startOf("hour")
                .toDate()
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { deal } = this.props;
              values.add_due_date = this.state.addDueDate;
              DealsService.takeAction(
                "create_lead_from_deal",
                deal.id,
                values
              ).then(data => {
                Alert.success("Follow Up was created");
                setSubmitting(false);
                history.push(`/m1/follow_ups/${data.lead.id}`);
              });
            }}
            render={({
              errors,
              touched,
              isValid,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
              values
            }) => (
              <Form>
                <FormikFormControl
                  fieldName="lead_type"
                  errors={errors}
                  touched={touched}
                >
                  <ControlLabel>Follow Up Type</ControlLabel>
                  <Field
                    className="form-control input-sm"
                    name="lead_type"
                    component="select"
                  >
                    <option value="">-- select --</option>
                    <option value="could_not_present_tcs">
                      Couldn't present TCS
                    </option>
                    <option value="could_not_confirm_tcs">
                      Couldn't confirm TCS
                    </option>
                    <option value="seminar_attended_did_not_book">
                      Seminar attended, did not book TCS
                    </option>
                    <option value="seminar_register_did_not_attend">
                      Booked Seminar, did not attend
                    </option>
                    <option value="dead_deal">Dead Deal</option>
                    <option value="other">Other</option>
                  </Field>
                </FormikFormControl>

                <FormikFormControl
                  fieldName="priority"
                  errors={errors}
                  touched={touched}
                >
                  <ControlLabel>Follow Up Priority</ControlLabel>
                  <Field
                    className="form-control input-sm"
                    name="priority"
                    component="select"
                  >
                    <option value="1">Urgent</option>
                    <option value="2">High Priority</option>
                    <option value="3">Normal</option>
                    <option value="4">Low Priority</option>
                    <option value="5">Unimportant</option>
                  </Field>
                </FormikFormControl>

                <FormikFormControl
                  fieldName="assign_lead_to"
                  errors={errors}
                  touched={touched}
                >
                  <ControlLabel>Assign it to</ControlLabel>
                  {users && (
                    <Field
                      className="form-control input-sm"
                      name="assign_lead_to"
                      component="select"
                    >
                      <option value="">-- nobody --</option>
                      {users &&
                        users.map(user => {
                          return (
                            <option key={user.email} value={user.email}>
                              {user.name}
                            </option>
                          );
                        })}
                    </Field>
                  )}
                </FormikFormControl>

                <FormikTextAreaControl
                  fieldLabel="Initial Notes / Explanation"
                  fieldName="initial_notes"
                  errors={errors}
                  touched={touched}
                />

                <Checkbox
                  checked={this.state.addDueDate}
                  onChange={() => {
                    this.setState({ addDueDate: !this.state.addDueDate });
                  }}
                >
                  Add a Due Date?
                </Checkbox>

                {this.state.addDueDate && (
                  <FormikFormControl
                    fieldName="due_at"
                    errors={errors}
                    touched={touched}
                  >
                    <ControlLabel>When</ControlLabel>
                    <FormikDatetime
                      field="due_at"
                      input={{
                        value: moment(values.due_at).format(
                          "DD MMM YYYY h:mma"
                        ),
                        onChange: setFieldValue,
                        onBlur: setFieldTouched
                      }}
                      closeOnSelect={true}
                      dateFormat="DD MMM YYYY"
                      timeFormat="h:mma"
                    />
                  </FormikFormControl>
                )}

                <div className="clearfix">
                  {onCancelSubmit && (
                    <Button onClick={onCancelSubmit} bsSize="small">
                      Whoops, cancel this
                    </Button>
                  )}
                  <Button
                    className="pull-right"
                    disabled={!isValid || isSubmitting}
                    type="submit"
                    bsStyle="info"
                    bsSize="small"
                  >
                    Create the Follow Up
                  </Button>
                </div>
              </Form>
            )}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default CreateLeadModal;
